package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class PayrollRepository(private val httpClient: HttpClient) {
    suspend fun getRecords(workplaceId: Long, from: String, to: String): Result<List<PayrollRecordDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/payroll") {
            parameter("from", from); parameter("to", to)
        }.body()
    }

    suspend fun createRecord(workplaceId: Long, req: CreatePayrollRecordRequest): Result<Long> = runCatching {
        httpClient.post("workplaces/$workplaceId/payroll") { setBody(req) }.body<Map<String, Long>>()["id"]!!
    }

    suspend fun updateRecord(recordId: Long, req: UpdatePayrollRecordRequest): Result<Unit> = runCatching {
        httpClient.put("payroll/$recordId") { setBody(req) }
    }

    suspend fun getSummary(workplaceId: Long, from: String, to: String): Result<List<PayrollSummaryDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/payroll/summary") {
            parameter("from", from); parameter("to", to)
        }.body()
    }

    suspend fun generatePayslips(workplaceId: Long, req: GeneratePayslipsRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/payslips/generate") {
            contentType(ContentType.Application.Json)
            setBody(req)
        }
    }

    suspend fun getPayslips(workplaceId: Long): Result<List<PayslipDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/payslips").body()
    }

    suspend fun publishPayslip(workplaceId: Long, payslipId: Long): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/payslips/$payslipId/publish")
    }

    suspend fun publishAllPayslips(workplaceId: Long): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/payslips/publish-all")
    }

    suspend fun getMyPayslips(): Result<List<PayslipDto>> = runCatching {
        httpClient.get("payroll/my-payslips").body()
    }
}
